import { Params } from '@angular/router';

export const featureFlag: Params = {
  // fetch swagger json from api docs
  useSwaggerUrl: false,
  // Warning dialog noticing that the api's cannot be consumed without a balance.
  alwaysShowPaymentWarning: true,
  useMonetizedCheck: false,
};
